import React from 'react';
import { Group, Skeleton } from '@landr/maestro';

export const SamplesTableActionsGroupSkeletons = ({
    isMd,
}: {
    isMd: boolean;
}) => (
    <Group
        gap="xs"
        direction="horizontal"
        justifyContent="flex-end"
        data-testid="samples-table-actions-skeletons"
    >
        {!isMd && (
            <>
                <Group.Item>
                    <Skeleton width="sm" height="sm" variant="round" />
                </Group.Item>
                <Group.Item>
                    <Skeleton width="sm" height="sm" variant="round" />
                </Group.Item>
            </>
        )}
        <Group.Item>
            <Skeleton width="sm" height="sm" variant="round" />
        </Group.Item>
        <Group.Item mr="none">
            <Skeleton width="sm" height="sm" variant="round" />
        </Group.Item>
        <Group.Item mr="none">
            <Skeleton width="sm" height="sm" variant="round" />
        </Group.Item>
    </Group>
);
